import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=4791ce7b"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
import style0 from "./Add.vue?vue&type=style&index=0&id=4791ce7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports